import { useId } from 'react';

import { useGetColor } from 'hooks';

import { IconPropsType } from './types';

export const LogoExtendedIcon = ({
  color,
  size,
  width = 125,
  height = 25,
  ...props
}: IconPropsType) => {
  const id = useId();
  const iconColor = useGetColor(color);

  return (
    <svg
      width={size ? '100%' : width}
      height={size ?? height}
      viewBox="0 0 125 25"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <clipPath id={`${id}_a`}>
          <path d="M1024 0v768H0V0h1024Z" />
        </clipPath>
        <clipPath id={`${id}_b`}>
          <path d="M23.17 0v25H0V0h23.17Z" />
        </clipPath>
        <clipPath id={`${id}_c`}>
          <path d="M10.912 0a7.351 7.351 0 0 1 7.04 5.221 7.244 7.244 0 0 1 3.087 1.843 7.256 7.256 0 0 1 2.132 5.162c-.002 4.022-3.296 7.294-7.343 7.294H8.422v2.567c0 1.128-.631 2.133-1.646 2.622a2.885 2.885 0 0 1-3.072-.35l-2.338-1.874A3.631 3.631 0 0 1 0 19.638V4.834A4.835 4.835 0 0 1 4.825 0h6.087ZM6.145 14.594H2.276v5.044c0 .417.187.806.512 1.066l2.337 1.874c.279.223.59.11.697.059.107-.052.323-.193.323-.55v-7.493Zm12.093-6.803a7.249 7.249 0 0 1-2.116 4.665 7.229 7.229 0 0 1-5.151 2.138H8.42v2.645h7.407c2.792 0 5.065-2.249 5.066-5.014.001-1.34-.52-2.6-1.465-3.549a5.027 5.027 0 0 0-1.19-.885Zm-7.326-5.51H4.825a2.554 2.554 0 0 0-2.549 2.553v7.48h3.87V9.76a4.835 4.835 0 0 1 4.825-4.834h4.404a5.079 5.079 0 0 0-4.463-2.645Zm5.065 4.926h-5.006A2.554 2.554 0 0 0 8.42 9.76v2.554h2.55a4.97 4.97 0 0 0 3.541-1.47 4.988 4.988 0 0 0 1.466-3.55v-.087Z" />
        </clipPath>
        <clipPath id={`${id}_d`}>
          <path d="M37.465 4.323c1.582 0 2.793.68 3.636 1.73V4.529h2.362v9.676c0 3.191-2.465 5.765-5.752 5.765-2.505 0-4.58-1.483-5.443-3.603H35c.616.761 1.458 1.235 2.711 1.235 1.972 0 3.39-1.523 3.39-3.397v-.082c-.843 1.05-2.054 1.73-3.636 1.73-3.184 0-5.546-2.574-5.546-5.765s2.362-5.765 5.546-5.765Zm-31.467 0c3.183 0 5.545 2.574 5.545 5.765 0 3.19-2.362 5.764-5.545 5.764-1.52 0-2.712-.638-3.533-1.606v5.518H0V4.529h2.362v1.524c.842-1.05 2.054-1.73 3.636-1.73Zm12.632 0c3.286 0 5.792 2.368 5.792 5.559 0 .391-.041.762-.123 1.132h-8.935c.37 1.42 1.623 2.47 3.266 2.47 1.253 0 2.095-.473 2.711-1.235h2.732c-.863 2.12-2.937 3.603-5.443 3.603-3.287 0-5.854-2.573-5.854-5.764 0-3.191 2.567-5.765 5.854-5.765Zm32.227 0c1.582 0 2.793.68 3.636 1.73V4.529h2.362v11.117h-2.362v-1.523c-.843 1.05-2.054 1.73-3.636 1.73-3.184 0-5.546-2.574-5.546-5.765s2.362-5.765 5.546-5.765Zm-19.349 0v2.738c-1.479-.103-2.773.783-2.773 2.368v6.217h-2.464V4.53h2.362v1.462c.657-1.03 1.643-1.668 2.875-1.668Zm40.012.02c2.26 0 4.108 1.854 4.108 4.118v7.185h-2.465v-6.65a2.238 2.238 0 0 0-2.218-2.223c-1.232 0-2.239 1.009-2.239 2.224v6.65h-2.465v-6.65a2.238 2.238 0 0 0-2.218-2.224c-1.232 0-2.239 1.009-2.239 2.224v6.65H59.32V4.528h2.362v1.05a4.077 4.077 0 0 1 2.916-1.235c1.459 0 2.732.762 3.472 1.914a4.053 4.053 0 0 1 3.45-1.914Zm9.038.186v11.117h-2.465V4.53h2.465Zm8.113-.206c2.835 0 4.622 2.059 4.622 4.9v6.423h-2.465V9.43a2.668 2.668 0 0 0-2.67-2.676 2.668 2.668 0 0 0-2.67 2.676v6.217h-2.465V4.53h2.362v1.4c.719-.988 1.807-1.606 3.286-1.606ZM5.69 6.753a3.317 3.317 0 0 0-3.328 3.335 3.317 3.317 0 0 0 3.328 3.335 3.317 3.317 0 0 0 3.327-3.335A3.317 3.317 0 0 0 5.69 6.753Zm32.083 0a3.317 3.317 0 0 0-3.327 3.335 3.317 3.317 0 0 0 3.327 3.335 3.317 3.317 0 0 0 3.328-3.335 3.317 3.317 0 0 0-3.328-3.335Zm13.392 0a3.317 3.317 0 0 0-3.327 3.335 3.317 3.317 0 0 0 3.327 3.335 3.317 3.317 0 0 0 3.328-3.335 3.317 3.317 0 0 0-3.328-3.335ZM18.63 6.65c-1.54 0-2.732.885-3.184 2.202h6.367C21.362 7.535 20.17 6.65 18.63 6.65ZM79.325 0c.925 0 1.644.72 1.644 1.647 0 .926-.72 1.647-1.644 1.647-.924 0-1.643-.72-1.643-1.647 0-.926.72-1.647 1.643-1.647Z" />
        </clipPath>
      </defs>
      <g clipPath={`url(#${id}_a)`} transform="translate(-29 -35)">
        <g clipPath={`url(#${id}_b)`} transform="translate(29.96 35)">
          <g clipPath={`url(#${id}_c)`}>
            <path fill={iconColor} d="M0 0h23.17v25H0V0z" />
          </g>
        </g>
        <g clipPath={`url(#${id}_d)`} transform="translate(60.6 36.067)">
          <path fill={iconColor} d="M0 0h93.293v19.97H0V0z" />
        </g>
      </g>
    </svg>
  );
};
